<script setup lang="ts">
import stores from '@jaaluu/stores';

const { courseStatus, curriculum } = stores.course.state;
const { langForeign, langNative } = stores.language.state;
const { courseProgress } = stores.courseProgress.state;

defineEmits<{
  openCourseMenu: [];
}>();
</script>

<template>
  <div
    class="d-flex justify-space-between align-center"
    v-if="courseStatus.isActive && curriculum.length > courseStatus.storyIdx"
  >
    <div class="min-width-title" v-if="langForeign && langNative && curriculum[courseStatus.storyIdx]">
      <div class="d-flex align-center">
        <div class="text-subtitle-2 text-primary font-weight-bold text-truncate">
          {{ courseStatus.storyIdx + 1 }}. {{ curriculum[courseStatus.storyIdx].title }}
        </div>
      </div>
      <!-- <v-progress-circular
                :model-value="courseProgress.overallProgress"
                :color="courseProgress.overallProgress === 100 ? 'success' : 'primary'"
                size="36"
                width="4"
              >
                <span class="text-caption font-weight-bold"
                  >{{ courseProgress.overallProgress }}%</span
                >
              </v-progress-circular> -->
      <div class="text-center w-100">
        <v-progress-linear
          v-if="courseProgress.stories[courseStatus.storyIdx]"
          :model-value="courseProgress.stories[courseStatus.storyIdx].progress"
          color="primary"
        >
        </v-progress-linear>
      </div>
    </div>
    <!-- <div v-if="courseStatus.trainIdx > -1" class="middle">
            {{
              TRANS[langForeign].course[
                curriculum[courseStatus.storyIdx].trainSteps[courseStatus.trainIdx]?.type
              ]
            }}
          </div> -->
  </div>
</template>

<style scoped>
.min-width-title {
  min-width: 70px;
}
.middle {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
</style>
